import BackendService from './BackendService';

export default class WidgetService {
  static getConfig(dealerId) {
    return BackendService.get(`/widgets/config/${dealerId}`);
  }

  static getButtonGroupsPreview(body) {
    return BackendService.post(`/widgets/buttonGroups/preview`, {
      body,
    });
  }

  static getStandaloneButtonsPreview(body) {
    return BackendService.post(`/widgets/standaloneButtons/preview`, {
      body,
    });
  }

  static updateConfig(dealerId, config) {
    return BackendService.put(`/widgets/config/${dealerId}`, {
      body: config,
    });
  }

  static uploadImage(formData) {
    return BackendService.post('/widgets/image', { formData }, true);
  }
}
